// TODO: Inform @onelittleant that these will need to be env variables after we get the go ahead and push to production.
// TODO: Will also need to be added to the https://console.cloud.google.com/google/maps-apis/studio/maps?project=booking-platform-838c0 project and update our .env files.
export const DESKTOP_MAP_ID = 'ae11a18de76790a3';
export const MOBILE_MAP_ID = '99d3ee3d25212002';

export const LOCALSTORAGE_SEARCH_ON_MOVE = 'searchOnMove';
export const LOCATION_POLYGON_PARAM = 'location_polygon';
export const ZOOM_PARAM = 'zoom';

export const LOCALSTORAGE_MAP_LAYER = 'map_layer';

// Initial camera for brands without `defaultMapCamera`. Google Maps must be
// created with a camera, or AdvancedMarkers attached to it can crash.
export const FALLBACK_MAP_CENTER = { lat: 0, lng: 0 };
export const FALLBACK_MAP_ZOOM = 2;
export const LISTINGS_CENTER_ZOOM = 12;
